// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_input-wrapper__oh3m8 {
  width: 100%;
  break-inside: avoid-column;
}
.Input_input-wrapper__oh3m8 .Input_input__eXwaT {
  position: relative;
}
.Input_input-wrapper__oh3m8 input {
  width: 100%;
  height: 40px;
  padding: 6px 12px;
  border: 1px solid #00007a;
  border-radius: 8px;
  outline: none;
  color: #00007a;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
.Input_input-wrapper__oh3m8 input:focus {
  border: 1px solid #1414ff;
}
.Input_input-wrapper__oh3m8 input::placeholder {
  color: #d8d8ff;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
.Input_input-wrapper__oh3m8 .Input_suffix__dgGOM {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
}
.Input_input-wrapper__oh3m8.Input_error__i7Rpt input {
  border: 1px solid #bd454a;
}
.Input_input-wrapper__oh3m8.Input_dark-bg__HipDi .Input_label__Dz5N0 {
  color: #fff;
}
.Input_input-wrapper__oh3m8.Input_dark-bg__HipDi input {
  border: none;
}
.Input_input-wrapper__oh3m8.Input_colabel__IxV-9 input::placeholder {
  color: #C3C3C9;
}

@media screen and (max-width: 600px) {
  .Input_input__eXwaT {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Input/Input.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,0BAAA;AAIF;AAFE;EACE,kBAAA;AAIJ;AADE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cCXO;EDYP,gBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;AADI;EACE,yBAAA;AAGN;AAAI;EACE,cC3BK;ED4BL,gBAAA;EACA,eAAA;EACA,iBAAA;AAEN;AAEE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AAAJ;AAII;EACE,yBAAA;AAFN;AAOI;EACE,WAAA;AALN;AAQI;EACE,YAAA;AANN;AAUE;EACE,cCxBgB;ADgBpB;;AAYA;EACE;IACE,WAAA;EATF;AACF","sourcesContent":["@use 'styles/colors';\n@use 'styles/sizes';\n\n.input-wrapper {\n  width: 100%;\n  break-inside: avoid-column;\n\n  .input {\n    position: relative;\n  }\n\n  input {\n    width: 100%;\n    height: 40px;\n    padding: 6px 12px;\n    border: 1px solid colors.$primary8;\n    border-radius: 8px;\n    outline: none;\n    color: colors.$primary8;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n\n    &:focus {\n      border: 1px solid colors.$primary5;\n    }\n\n    &::placeholder {\n      color: colors.$primary2;\n      font-weight: 300;\n      font-size: 16px;\n      line-height: 28px;\n    }\n  }\n\n  .suffix {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 18px;\n  }\n\n  &.error {\n    input {\n      border: 1px solid colors.$danger5;\n    }\n  }\n\n  &.dark-bg {\n    .label {\n      color: #fff;\n    }\n\n    input {\n      border: none;\n    }\n  }\n\n  &.colabel input::placeholder{\n    color: colors.$colabelNeutralMid;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .input {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"input-wrapper": `Input_input-wrapper__oh3m8`,
	"input": `Input_input__eXwaT`,
	"suffix": `Input_suffix__dgGOM`,
	"error": `Input_error__i7Rpt`,
	"dark-bg": `Input_dark-bg__HipDi`,
	"label": `Input_label__Dz5N0`,
	"colabel": `Input_colabel__IxV-9`
};
export default ___CSS_LOADER_EXPORT___;
